import { render, staticRenderFns } from "./Navigation-Component.vue?vue&type=template&id=93cdbc72&scoped=true&"
import script from "./Navigation-Component.vue?vue&type=script&setup=true&lang=js&"
export * from "./Navigation-Component.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Navigation-Component.vue?vue&type=style&index=0&id=93cdbc72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cdbc72",
  null
  
)

export default component.exports